var path = '/card/component/tpl/app-mva-embed.html';
var html = "<div class=media> <img ng-if=!$ctrl.isMobile ng-src={{$ctrl.item.images.original.url}} ng-click=$ctrl.expand() /> <ng-bind-html ng-if=$ctrl.isMobile ng-bind-html=$ctrl.embedCode($ctrl.item.app)></ng-bind-html> </div> <div class=main ng-if=\"$ctrl.item.title || $ctrl.item.description\"> <h3 dynamic-bind-html={{$ctrl.item.title}}></h3> <thismoment-description ng-if=$ctrl.item.description description={{$ctrl.item.description}}></thismoment-description> <thismoment-glow-cart-item content-id=$ctrl.item.id ng-if=$ctrl.cartEnabled></thismoment-glow-cart-item> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/card/component/tpl/app-mva-embed.html
// module id = 193
// module chunks = 1 2 3 4